<template>
  <button
    :type="type"
    class="button-base"
    :class="{'w-100': full}"
    @click="$emit('click'); $emit('clicked')"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'button'
      },

      full: {
        type: Boolean,
        default: false,
      },

      disabled: {
        type: Boolean,
        default: false
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .button-base {
    padding: 8px 24px;
    color: $white300;
    font-size: 0.89rem;
    border-radius: 4px;
    border: 1px solid rgba(255, 222, 91, 0.10);
    background: $orange600;
    
    &:hover, &:focus {
      background: $orange700;
    }
  }
</style>